var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHazardousWaste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M14.6,37.1l4.9-8.4c-1.8-1-2.9-2.9-3-4.9H6.9C6.9,29.3,9.9,34.3,14.6,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M38.1,23.8h-9.7c-0.1,2.1-1.3,4-3.1,5l4.9,8.3C35.1,34.4,38.1,29.3,38.1,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M22.6,17.6c1.1,0,2.3,0.4,3.2,1l4.7-8.6c-2.4-1.3-5.1-2.1-7.9-2.1c-2.8,0-5.5,0.7-7.9,2.1l4.6,8.6 C20.2,18,21.4,17.6,22.6,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M25.6,23.6c0-1.7-1.4-3.1-3.1-3.1s-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1S25.6,25.3,25.6,23.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazardousWaste);
export default __webpack_public_path__ + "static/media/hazardous_waste.f35265ae90b9d34fcd492d20273ec0a4.svg";
export { ForwardRef as ReactComponent };